import api from './api'
import {prop} from 'ramda'
import Debug from 'debug'
const debug = Debug('app:shared:payroll')

const payroll = ($http, $q, Auth) => {
  'ngInject'

  let payrollData = {}

  const fetchPayroll = (data) => {
    debug('fetch Payroll %o', data)
    return $http({
      method: 'POST',
      contentType: 'application/json',
      url: `${api.getBase()}/company/payroll`,
      data: data /* week, company_id, allCompanies */
    })
    .then(prop('data'), (err) => { throw err })
    .then(setPayrollData)
  }

  const getPayrollReport = (data) => {
    debug('get admin payroll %o', data)

    return $http({
      method: 'GET',
      contentType: 'application/json',
      url: `${api.getBase()}/payroll/payroll-report`,
      params: {
        week: data.week
      }
    })
    .then(response => {
      return response.data
    }, err => { throw err })
  }

  /**
   * Gets payroll approval data for all the manage jobs companies.
   * @param {object} data
   * @param {string} data.allCompanies - 'all' get the needed approval
   * @param {bool} data.sortByApproved - sort the list by approved timestamps
   * @param {number} data.week (optional) - 4 digit weeks since epoch number that corresponds to the payroll week
   */
  const fetchPayrollHours = (data) => {
    // TODO: modify some state in the factory.
    return $http({
      method: 'POST',
      url: `${api.getBase()}/payroll/hours`,
      data
    })
      .then(prop('data'))
  }

  const fetchInvoicePreview = (data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/invoices/preview`,
      data,
      responseType: 'arraybuffer'
    })
      .then(prop('data'))
  }

  const getUserPayroll = (data) => {
    debug('getting user Payroll Data %o', data)
    return $http({
      method: 'POST',
      contentType: 'application/json',
      url: `${api.getBase()}/user/getPayroll`,
      data: {
        week: data.week,
        userId: data.userId
      }
    })
    .then(prop('data'), (err) => { throw err })
  }

  const getUserPaystub = (data) => {
    debug('getting user Payroll Data %o', data)
    return $http({
      method: 'POST',
      contentType: 'application/json',
      url: `${api.getBase()}/payroll/getUserPaystub`,
      data: {
        week: data.week,
        userId: data.userId
      }
    })
    .then(prop('data'), (err) => { throw err })
  }

  const setPayrollData = (response) => {
    payrollData = response
    debug(payrollData)
    return payrollData
  }

  const approveShift = (data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/payroll/approve`,
      data: data
    })
  }


  /** 
   * @param {number} status Users Hours Status
   * @param {string} userId External User Id 
   * @param {string} jobId External Job Id 
   * @param {number} shift shift index
   * @param {number} reason reason code 
   * @param {text} note reason text
   */
  const updateHoursStatus = (status, userId, jobId, shift, reason, note) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/payroll/updateHoursStatus`,
      data: {
        userId,
        jobId,
        shift,
        status,
        reason,
        note
      }
    })
  }

  const undoHours = (data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/payroll/undo`,
      data: data
    })
    .then(prop('data'))
  }

  /**
   * 
   * @param {*} userId 
   * @param {*} selectedAccounts 
   * @param {string} confirmationCode 
   * @returns 
   */
  const plaidSaveAccount = (userId, selectedAccounts, confirmationCode) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/plaid/saveAccount`,
      data: {
        bankAccounts: selectedAccounts,
        userId: userId,
        confirmationCode
      }
    })
    .then(prop('data'))
  }

  const sendMassPayment = () => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/dwolla/transfer/sendMassPayment`
    })
    .then(prop('data'))
  }

  const saveDirectDepositInfo = (userId, data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/users/${userId}/addFundingSource`,
      data: {
        bankName: data.bankName,
        accountType: data.accountType,
        routingNumber: data.routingNumber,
        accountNumber: data.accountNumber,
        confirmationCode: data.confirmationCode
      }
    })
    .then(prop('data'))
  }

  const getFailedPayments = () => {
    return $http({
      method: 'GET',
      url: `${api.getBase()}/payments/failed`
    })
    .then(prop('data'))
  }

  const getPendingPayments = () => {
    return $http({
      method: 'GET',
      url: `${api.getBase()}/payments/pending`
    })
    .then(prop('data'))
  }

  const reschedulePayment = (id, method) => {
    if (method !== 'check' && method !== 'directDeposit') {
      return
    }
    return $http({
      method: 'POST',
      url: `${api.getBase()}/dwolla/status/${id}/reschedulePayment`,
      data: {method}
    })
    .then(prop('data'))
  }

  const updateVensureIds = (data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/vensure/updateIdsFromPortal`,
      data
    })
    .then(prop('data'))
  }

  const newHireCSV = (data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/vensure/newHireExport`,
      data
    })
  }

  /**
   * @param {number} userId 
   */
  const sendConfirmationCode = (userId) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/users/${userId}/sendConfirmationCode`,
    })
    .then(null, (err) => { throw err })
  }

  return {
    fetchPayroll,
    fetchPayrollHours,
    fetchInvoicePreview,
    getPayrollReport,
    approveShift,
    newHireCSV,
    undoHours,
    getFailedPayments,
    getPendingPayments,
    getUserPayroll,
    getUserPaystub,
    sendMassPayment,
    updateVensureIds,
    plaidSaveAccount,
    reschedulePayment,
    saveDirectDepositInfo,
    updateHoursStatus,
    sendConfirmationCode,
  }
}

export default payroll
